import { EmailBasicDto, EmailSendModeDto } from '@/api/generated';
import {
  NEW_EMAIL_REDUCER_EVENT,
  NEW_EMAIL_VIEW_MODE,
  useNewEmailUpdateState,
} from '@/views/emails/context/NewEmails.ts';

type Params = {
  email: EmailBasicDto;
  openInFloatingMode?: boolean;
};

type Return = {
  handleForward: (params: Params) => () => void;
  handleReply: (params: Params) => () => void;
  handleReplyAll: (params: Params) => () => void;
};

export const useControlButtonsActions = (): Return => {
  const updateNewEmailState = useNewEmailUpdateState();

  const handleEmailClick = (params: Params, emailMode: EmailSendModeDto) => {
    updateNewEmailState({
      payload: {
        attachments: [],
        draftRequestId: crypto.randomUUID(),
        email: params.email,
        mode: emailMode,
      },
      type: NEW_EMAIL_REDUCER_EVENT.WRITE_EMAIL,
    });
    if (params.openInFloatingMode) {
      updateNewEmailState({
        payload: { mode: NEW_EMAIL_VIEW_MODE.FLOATING_WINDOW },
        type: NEW_EMAIL_REDUCER_EVENT.CHANGE_WINDOW_MODE,
      });
    }
  };

  const handleReply = (params: Params) => () => {
    handleEmailClick(params, EmailSendModeDto.Reply);
  };

  const handleReplyAll = (params: Params) => () => {
    handleEmailClick(params, EmailSendModeDto.ReplyAll);
  };

  const handleForward = (params: Params) => () => {
    handleEmailClick(params, EmailSendModeDto.Forward);
  };

  return {
    handleForward,
    handleReply,
    handleReplyAll,
  };
};
